import { useChosenLevel } from '../../../../hooks/useChosenLevel.js';
import ActionsBarFactory from './ActionsBar/ActionsBarFactory.jsx';
import { SummaryFactory } from './Summary/SummaryFactory.jsx';

const Header = () => {
  const { level } = useChosenLevel();

  return (
    <div className="w-full">
      <SummaryFactory level={level} />
      <ActionsBarFactory level={level} />
    </div>
  );
};

export default Header;
